<template>
    <div class="perLibary ">
        <div class="allBox app-body">
            <page-header @openLoginDiolog="goLogin" :state="isHaveLoginObj" @goExamintercept="judgeIslogin"/>
            <keep-alive>
                <scree-compent ref="scree" :type="currentLibary"></scree-compent>
            </keep-alive>

            <div class="bottom">
                <div class="nav xy-between">
                    <div class="nav-tive jf">
                        <div class="topic xy-center" v-for="(item,i) in ColumnInfo" :key="i" @click="selectColum(item)">
                            <div class="yx-center" :class="{'avtie' : currentSatus === item.id }">
                                <div class="cursor">{{item.name}}</div>
                                <div class="throw" v-if="currentSatus === item.id"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 列表 -->
                <div class="chapterList ">
                    <div class="directory">
                        <div class="chapterTree" v-if="firstChapterList && firstChapterList.length !== 0" v-loading="fristListLoading">
                            <div class="one" v-for="(item,i) in firstChapterList" :key="i">
                                <div class="jf son">
                                    <div class="name font-size16 jf">
                                        <div class="symbol xy-center">
                                            <i v-if="item.childrenId && item.levalShow" class="el-icon-plus"
                                                @click="showLeave(item)"></i>
                                            <i v-else class="el-icon-minus" @click="shrinkageLeave(item)"></i>
                                        </div>
                                        <div @click="FristChapterShow(item)" class="cursor">
                                            第{{i+1}}章&nbsp;&nbsp;{{item.name}}</div>
                                    </div>
                                    <div class="topicNum font-size14">{{item.question_count}}道</div>
                                    <div class="makeTopic font-size14 xy-center ">
                                        <div class="btn" v-if="item.freeFlag || item.buyState">
                                            <div class="arrow xy-center" v-if="item.childrenId"
                                                @click="FristChapterShow(item)">
                                                <i v-if="item.children && item.children.length "
                                                    class="el-icon-arrow-up font-size18"></i>
                                                <i v-else class="el-icon-arrow-down font-size18"></i>
                                            </div>
                                            <div v-else @click="makeTopic(item)">
                                                开始做题
                                            </div>
                                        </div>
                                        <div class="btn" v-else @click="buyCourse(item)">
                                            <div class="lock" v-if="!item.buyState">
                                                <i class="el-icon-lock"></i>
                                                <span>购买</span>
                                            </div>
                                            <div v-else>
                                                <div v-if="item.childrenId" class="test" @click="nexOneLevel(item)">
                                                    <i v-if="item.childrenId"
                                                        class="el-icon-arrow-down"></i>
                                                    <i v-else class="el-icon-arrow-right"></i>
                                                </div>
                                                <div v-else @click="makeTopic(item)">
                                                    开始做题
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 二级 -->
                                <div class="twoParant" v-if="item.children && item.children.length ">
                                    <div class="two" v-for="(item2,i) in item.children" :key="i">
                                        <div class="jf son">
                                            <div class="name font-size16 jf">
                                                <div class="symbol xy-center ">
                                                    <i v-if="item2.childrenId " class="el-icon-plus "
                                                        @click="showLeave(item)"></i>
                                                    <i v-else class="el-icon-minus" @click="shrinkageLeave(item)"></i>
                                                </div>
                                                {{i+1}}.&nbsp;{{item2.name}}
                                            </div>
                                            <div class="topicNum font-size14">{{item2.count ? item2.count : 0}}道</div>
                                            <div class="makeTopic font-size14 xy-center ">
                                                <div class="btn" v-if="item2.freeFlag || item2.buyState">
                                                    <div class="arrow xy-center" v-if="item2.childrenId">
                                                    </div>
                                                    <div v-else @click="makeTopic(item,item2)">
                                                        开始做题
                                                    </div>
                                                </div>
                                                <div class="btn" v-else @click="buyCourse(item)">
                                                    <div class="lock" v-if="!item2.buyState">
                                                        <i class="el-icon-lock"></i>
                                                        <span>购买</span>
                                                    </div>
                                                    <div v-else>

                                                        <div class="arrow xy-center" v-if="item2.childrenId"
                                                            @click="nexOneLevel(item2)">
                                                            <i v-if="item2.children && item2.children.length "
                                                                class="el-icon-arrow-down"></i>
                                                            <i v-else class="el-icon-arrow-right"></i>
                                                        </div>
                                                        <div v-else @click="makeTopic(item,item2)">
                                                            开始做题
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 三级 -->
                                        <div v-if="false" class="three ">
                                            <div class="jf son">
                                                <!-- <i class="el-icon-remove font-size18 c-256CF4"></i> -->
                                                <div class="name font-size16">第五章 建设工程职业健康安全与环境管理</div>
                                                <div class="topicNum font-size14">39/325道</div>
                                                <div class="makeTopic font-size14 xy-center ">开始做题</div>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- 二级 -->
                                </div>
                                <!-- 二级 -->
                            </div>
                        </div>
                        <div class="chapterTree" v-else>
                            <el-empty description="暂无数据~"></el-empty>
                        </div>
                    </div>
                    <div class="makeTopicNum">
                        <div class="title font-size16">
                            <span>当前科目：</span>
                            <span class="subName">{{currentColumName}}</span>
                        </div>
                        <div class="total xy-between">
                            <div class="num yx-between">
                                <div>总题数</div>
                                <div>
                                    <span>{{currentTotal ? currentTotal.sumcount : "0" }}</span>
                                    道
                                </div>
                            </div>
                            <div class="num yx-between">
                                <div>已做题数</div>
                                <div>
                                    <span>{{currentTotal ? currentTotal.usecount : "0" }}</span>
                                    道
                                </div>
                            </div>
                            <div class="num yx-between">
                                <div>正确题数</div>
                                <div>
                                    <span>{{currentTotal ? currentTotal.rightcount : "0" }}</span>
                                    道
                                </div>
                            </div>
                        </div>
                        <div class="btn jf">
                            <div class="test xy-center cursor font-size16" @click="goGroupPaper">
                              <i class="el-icon-date font-size16 "></i>
                                组卷模考
                            </div>
                            <div class="errTopic xy-center cursor font-size16" @click="wrongTopicReset">
                               <i class="el-icon-thumb"></i>
                                错题重做
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!-- 登录框 -->
             <login-diolog :show.sync="loginDiologShow" @changeLoginState="haveLogin"></login-diolog>
        <!-- 登录框 -->
        <div class="selectType yx-center" @click="goPerTopicLibary">
            <img src="../../assets/img/tiku.png" alt="">
            <div class="c-fff">机构题库</div>
        </div>
        <el-backtop :bottom="300">
            <div class="test xy-center ">
                <i class=" el-icon-arrow-up font-size50"></i>
            </div>
        </el-backtop>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import {
    GetQuestionRecord
} from "@/api/questionPaper"
import {
    GetColumnInfo,
    GetFirstSubChapterInfo,
    GetSubChapterInfo
} from "@/api/category";
import PageHeader from "@/components/header";
import ScreeCompent from "@/components/publicSort";
import BottomGround from "@/components/bottomnav";
import LoginDiolog from "@/components/loginDiolog";
import { isEqual } from "lodash"
import store from "@/store";
import { getCommonQlMenu } from "@/api/new-question-iteration/question-library";
export default {
    name: "publicLibary",
    components: {
        PageHeader,
        ScreeCompent,
        BottomGround,
        LoginDiolog
    },
    data() {
        return {
            currentLibary: "pub", // 类型为公共题库
            currentSatus: "",
            passClassId: "", // 子传父的id
            ColumnInfo: [],
            firstChapterList: [],
            page: 1,
            page_size: 99999,
            fristListLoading: true,
            fristPages: 0,
            sortData: [],
            currentColumName: "",
            currentColumId: "",
            // 统计当前正确题数量
            currentTotal: {},
            loginDiologShow: false,
            isHaveLoginObj: "",
            jumpFromResource: false

        }
    },
    computed: {},
    beforeRouteEnter(to, from, next) {
        // if (store.state.user) {
        //     next()
        // } else {
        //     window.$bus.$emit("login")
        //     next(false)
        // }
        next()
    },
    mounted() {},
    watch: {
        passClassId(newVal) {
            console.log(newVal, "passClassId");
            this.page = 1
            this.fristPages = 0
            this.GetColumnInfo()
            this.cycSerachName(this.sortData)
        },
        "$route" (to, from) {
            if (from.name === "publicMake") {
                // this.GetFirstSubChapterInfo()
            }
        }
    },
    activated() {
        window.scroll(0, 0)
        let nQuery = this.$route.query;
        if (!isEqual(nQuery, this.routeQuery || {})) {
            this.$refs.scree.GetSystemCategoryInfo();
            this.routeQuery = nQuery;
        }
        if (this.currentSatus) {
            this.GetFirstSubChapterInfo();
        }
    },
    methods: {
        goGroupPaper() {
            // 判断是否登录
            let token = this.$store.state.user
            if (!token || token === "null") {
                this.goLogin()
                return
            }
            this.$router.push("/gropuPaper")
        },
        // 判断是否登录
        judgeIslogin() {
            let token = this.$store.state.user
            if (!token || token === "null") {
                this.goLogin()
                return
            }
        },
        goLogin() {
            this.loginDiologShow = true
        },
        haveLogin(val) {
            this.isHaveLoginObj = val
        },
        // 错题重做
        wrongTopicReset() {
            // 判断是否登录
            let token = this.$store.state.user
            if (!token || token === "null") {
                this.goLogin()
                return
            }
            this.GetQuestionRecord()
        },
        async GetQuestionRecord() {
            const {
                data
            } = await GetQuestionRecord({
                pageno: 1,
                pagesize: 99999,
                sourceType: 1,
                type: 1,
                searchkey: ""
            })
            if (data.data.length === 0) {
                this.$message({
                    type: "warning",
                    message: "暂无错题"
                })
                return
            }
            let obj = {}
            obj.info = data.data
            obj.type = "publicCollect"
            obj.currentTopic = data.data[0]
            obj.libaryType = "公共题库"
            window.localStorage.setItem("TopicInfo", JSON.stringify(obj))
            this.$router.push("/publicMake")
        },
        buyCourse(val) {
            let token = this.$store.state.user
            if (!token || token === "null") {
                this.goLogin()
                return
            }
            this.$router.push({
                path: "/resourceOrder",
                query: {
                    columId: this.currentColumId
                }
            })
        },
        FristChapterShow(val) {
            if (val.children && val.children.length) {
                this.shrinkageLeave(val)
            } else {
                this.showLeave(val)
            }
        },
        makeTopic(val, val2) {
            // 判断是否登录
            // let token = this.$store.state.user
            // if (!token || token === "null") {
            //     this.goLogin()
            //     return
            // }
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                return this.goLogin();
            }
            if (val2) {
                if (!val2.count) {
                    this.$message("暂无试题")
                    return
                }
                let obj = {}
                obj.nameObject = {
                    columName: this.currentColumName,
                    columId: this.currentColumId,
                    first: val.name,
                    firstId: val.id,
                    second: val2.name,
                    secondId: val2.id
                }
                obj.info = val2
                obj.type = "public"
                window.localStorage.setItem("TopicInfo", JSON.stringify(obj))
                this.$router.push("/publicMake")
                return
            } else {
                if (!val.question_count) {
                    this.$message("暂无试题")
                    return
                }
                let obj = {}
                obj.nameObject = {
                    columName: this.currentColumName,
                    columId: this.currentColumId,
                    first: val.name,
                    firstId: val.id
                }
                obj.info = val
                obj.type = "public"
                window.localStorage.setItem("TopicInfo", JSON.stringify(obj))
                this.$router.push("/publicMake")
            }
        },
        //  找分类名称
        cycSerachName(arr) {
            arr.forEach(v => {
                if (v.id === this.passClassId) {
                    this.currentColumName = v.name
                    this.currentColumId = v.id
                    window.localStorage.setItem("CURRENT_ID", JSON.stringify(this.passClassId))
                    return
                }
                if (v.children && v.children.length) {
                    this.cycSerachName(v.children)
                }
            })
        },
        currentPage(val) {
            this.page = val
            this.GetFirstSubChapterInfo()
        },
        selectColum(item) {
            this.currentSatus = item.id
            this.page = 1
            this.fristPages = 0
            this.GetFirstSubChapterInfo()
        },
        // 获取栏目信息
        async GetColumnInfo() {
            try {
                if (this.passClassId) {
                    const {
                        data
                    } = await GetColumnInfo({
                        categoryId: this.passClassId
                    });
                    console.log(this.passClassId, "passClassId");
                    if (data.code === 100) {
                        this.ColumnInfo = data.data;
                        let routeCategoryId = this.$route.query.categoryId
                        if (routeCategoryId && !this.jumpFromResource) {
                            this.currentSatus = routeCategoryId
                            this.jumpFromResource = true
                        } else {
                            this.currentSatus = this.ColumnInfo[0]?.id || ""
                        }
                        // 加载第一级章节
                        this.GetFirstSubChapterInfo()
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
        async GetFirstSubChapterInfo() {
            this.fristListLoading = true
            try {
                const {
                    data
                } = await GetFirstSubChapterInfo({
                    columnId: this.currentSatus,
                    categoryId: this.passClassId,
                    pageno: this.page,
                    pagesize: this.page_size
                })
                console.log(data, "data");
                this.currentTotal = data.extendfield
                this.fristPages = data.count
                this.fristListLoading = false
                data.data.forEach((v, i) => {
                    if (v.question_count === "0") {
                        data.data.splice(i, 1)
                    }
                })
                // // 获取当前权限
                // // 获取用户信息
                // let userInfo = this.$store.state.userInfo
                // // 0 代表全部权限  1代表PC端的权限 2代表APP端的权限 -1代表无权限
                // if (userInfo && userInfo.resourceLimit === "0") {
                //     data.data.forEach(c => {
                //         c.freeFlag = 0
                //     })
                // } else if (userInfo && userInfo.resourceLimit === "1") {
                //     data.data.forEach(c => {
                //         c.freeFlag = 0
                //     })
                // } else if (userInfo && userInfo.resourceLimit === "-1") {
                //     data.data.forEach(c => {
                //         c.freeFlag = 1
                //     })
                // }
                // 判断相反的
                // freeFlag:1是收费的，0是免费
                data.data.forEach(v => {
                    if (v.freeFlag) {
                        v.freeFlag = 0
                    } else {
                        v.freeFlag = 1
                    }
                })
                this.firstChapterList = []
                this.firstChapterList.push(...data.data)
                this.firstChapterList.forEach(v => {
                    v.levalShow = true
                })
            } catch (error) {
                console.log("error--", error)
            }
        },
        async GetSubChapterInfo(val) {
            try {
                const {
                    data
                } = await GetSubChapterInfo({
                    columnId: this.currentSatus,
                    chapterId: val.id,
                    pageno: 1,
                    pagesize: 999999
                })
                if (val.freeFlag && !val.buyState) {
                    data.data.forEach(v => {
                        v.buyState = false
                        v.freeFlag = 1
                    })
                }
                this.cycAddChild(this.firstChapterList, val, data.data)
            } catch (error) {
                console.log(error);
            }
        },
        // 展开第一章
        showLeave(val) {
            this.firstChapterList.forEach(v => {
                if (v.id === val.id) {
                    v.levalShow = false
                }
            })
            this.CycCurrentChapter(this.firstChapterList, val)
            this.$forceUpdate()
        },
        // 收缩第一级
        shrinkageLeave(val) {
            this.firstChapterList.forEach(v => {
                if (val.childrenId && v.id === val.id && !v.levalShow) {
                    v.levalShow = true
                }
            })
            val.children = []
            this.$forceUpdate()
        },
        nexOneLevel(val) {
            //  点击关闭下级列表
            if (val.children && val.children.length) {
                val.children = []
                this.$forceUpdate()
            } else {
                this.CycCurrentChapter(this.firstChapterList, val)
            }
        },
        CycCurrentChapter(arr, val) {
            arr.forEach(v => {
                if (v.id === val.id && v.childrenId) {
                    this.GetSubChapterInfo(val)
                }
            });
        },
        cycAddChild(arr, val, childrenArr) {
            arr.forEach(v => {
                if (v.id === val.id && v.childrenId) {
                    v.children = childrenArr
                    this.$forceUpdate()
                    return
                }
                if (v.children && v.children.length) {
                    this.cycAddChild(v.children, val, childrenArr)
                }
            });
        },
        goPerTopicLibary() {
            if (this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                return this.goLogin();
            }
            this.$router.push("/question/organ")
        }
    }
}

</script>

<style scoped lang="less">
    .perLibary {
        width: 100%;
        height: 100%;

        .bottom {
            height: 100%;
            box-sizing: border-box;
            margin: 0 auto;

            .nav {
                width: 100%;
                height: 62px;
                background-color: white;
                padding: 0 30px;
                box-sizing: border-box;
                margin-bottom: 1px;
                margin-top: 20px;

                .tit {
                    ::v-deep p {
                        font-size: 14px;

                    }
                }

                .nav-tive {
                    font-size: 16px;
                    color: #72777F;

                    .topic {
                        margin-right: 60px;
                    }

                    .paper {
                        height: 62px;
                        width: 100px;
                    }

                    .throw {
                        margin-top: 2px;
                        width: 20px;
                        height: 4px;
                        background: #256CF4;
                        border-radius: 2px;
                    }

                    .avtie {
                        color: #256CF4;
                        margin-top: 4px;
                    }
                }

                ::v-deep .el-input {
                    .el-input__inner {
                        border-color: #4A78D4;
                        ;

                    }

                    .el-input-group__append {
                        background-color: #256CF4;
                        border: 2px solid #256CF4;
                        color: white;
                    }
                }

            }

            .chapterList {
                width: 100%;
                display: flex;
                padding-bottom: 50px;
                box-sizing: border-box;

                .directory {
                    width: 70%;
                    background-color: white;
                    // padding: 30px;
                    // box-sizing: border-box;

                    .chapterTree {
                        padding: 20px;
                        box-sizing: border-box;
                        // margin-top: 30px;
                        min-height: 100px;
                        height: 600px;
                        height: 600px;
                        overflow: auto;

                        .son {
                            height: 70px;
                        }

                        .son:hover {
                            background-color: #F0F1F5;
                        }

                        .son:hover .makeTopic .btn .arrow {
                            background-color: #F0F1F5 !important;
                        }

                        .one {

                            .son {
                                padding-left: 10px;
                                border-bottom: 1px solid #E5E8EC;
                                position: relative;
                                .makeTopic {
                                    position: absolute;
                                    right: 30px;
                                    .btn {
                                        width: 100%;
                                        height: 100%;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        cursor: pointer;

                                        .arrow {
                                            width: 100%;
                                            height: 100%;
                                            font-size: 30px;
                                            background-color: white;
                                            color: #256CF4;
                                        }

                                        .lock {
                                            width: 100%;
                                            height: 100%;
                                            border-radius: 4px;
                                            background: #256CF4;
                                            color: white;
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                        }
                                    }
                                }
                            }

                            .el-icon-remove {
                                opacity: 0.8;
                            }

                            .name {
                                width: 500px;
                                margin-left: 10px;

                                .symbol {
                                    border-radius: 50%;
                                    width: 15px;
                                    height: 15px;
                                    background-color: #DEE9FE;
                                    color: #5B90F7;
                                    margin-right: 5px;
                                    flex-shrink: 0;
                                }
                            }

                            .topicNum {
                                width: 100px;
                                color: #858B94;
                            }

                            .makeTopic {
                                width: 96px;
                                height: 32px;
                                background: #256CF4;
                                border-radius: 4px;
                                color: white;
                                margin-left: 50px;
                            }

                            .twoParant {
                                // background-color: #F7F8FC;
                                // ;
                            }

                            .two {
                                .son {
                                    padding: 0 0 0 55px;
                                    box-sizing: border-box;
                                    border-bottom: 2px solid #E5E8EC;
                                    position: relative;
                                }

                                .el-icon-remove {
                                    opacity: 0.8;
                                }

                                .name {
                                    width: 380px;
                                    // margin-left: 10px;
                                }

                                .topicNum {
                                    width: 50px;
                                    color: #858B94;
                                    margin-left: 75px;
                                }

                                .makeTopic {
                                    width: 96px;
                                    height: 32px;
                                    background: #E9F0FD;
                                    border-radius: 4px;
                                    color: #256CF4;
                                    position: absolute;
                                    right: 30px;
                                }

                                .three {
                                    .son {
                                        padding: 0 30px 0 60px;
                                        box-sizing: border-box;
                                    }

                                    .el-icon-remove {
                                        opacity: 0.8;
                                    }

                                    .name {
                                        width: 600px;
                                        margin-left: 10px;
                                    }

                                    .topicNum {
                                        width: 100px;
                                        color: #858B94;
                                    }

                                    .makeTopic {
                                        width: 96px;
                                        height: 32px;
                                        background: #E9F0FD;
                                        border-radius: 4px;
                                        color: #256CF4;
                                    }
                                }
                            }
                        }

                        &::-webkit-scrollbar {
                            width: 6px;
                        }

                        &::-webkit-scrollbar-track {
                            border-radius: 6px;
                        }

                        &::-webkit-scrollbar-thumb {
                            border-radius: 6px;
                            background: #BAC0CA;
                        }

                    }

                    .paging {
                        margin-top: 20px;
                    }
                }

                .makeTopicNum {
                    width: 30%;
                    height: 320px;
                    background-color: white;
                    box-sizing: border-box;
                    box-sizing: border-box;
                    border-left: 1px solid #F1F2F6;

                    .title {
                        height: 70px;
                        line-height: 70px;
                        padding-left: 20px;
                        border-bottom: 1px dashed #F1F2F6;

                        .subName {
                            word-wrap: break-word;
                            word-break: break-all;
                            word-wrap: break-word;
                        }

                    }

                    .total {
                        height: 150px;
                        padding: 0 20px;
                        border-bottom: 1px solid #F1F2F6;

                        .num {
                            width: 85px;
                            height: 100px;
                            background: #F3F5F9;
                            border-radius: 4px;
                            padding: 20px 0;
                            box-sizing: border-box;
                            font-size: 14px;

                            span {
                                font-size: 16px;
                                color: #FF4751;
                            }
                        }
                    }

                    .btn {
                        height: 100px;
                        line-height: 100px;
                        padding-left: 60px;
                        i{
                            margin-right: 5px;
                        }
                        .test {
                            width: 120px;
                            height: 40px;
                            background: #F9F9FA;
                            border-radius: 8px 0px 0px 8px;
                            border: 1px solid #E5E8EC;
                        }
                    }

                    .errTopic {
                        width: 120px;
                        height: 40px;
                        background: #256CF4;
                        border-radius: 0px 8px 8px 0px;
                        color: white;
                    }
                }
            }

        }

        .selectType {
            width: 80px;
            height: 88px;
            background: #256CF4;
            box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
            border-radius: 8px;
            position: fixed;
            right: 40px;
            bottom: 365px;

            img {
                width: 35px;
                height: 40px;
            }
        }

        .el-backtop {
            width: unset;
            right: 40px !important;
            bottom: 300px !important;

            .test {
                width: 80px;
                height: 80px;
                background: #FFFFFF;
                box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
                border-radius: 8px;
            }
        }
    }

</style>
